import { useEffect, useState } from "react";

/**
 * Returns a compact human-readable countdown to a target ISO datetime,
 * or "Fermé" if the target is in the past.
 */
export function useCountdown(targetIso) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!targetIso) return { closed: false, label: "" };
  const target = new Date(targetIso).getTime();
  const diff = target - now;
  if (diff <= 0) return { closed: true, label: "Fermé" };

  const totalSec = Math.floor(diff / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const mins = Math.floor((totalSec % 3600) / 60);
  const secs = totalSec % 60;

  let label;
  if (days > 0) label = `${days}j ${hours}h`;
  else if (hours > 0) label = `${hours}h ${String(mins).padStart(2, "0")}m`;
  else if (mins > 0) label = `${mins}m ${String(secs).padStart(2, "0")}s`;
  else label = `${secs}s`;

  return { closed: false, label, hours, mins, secs, days, urgent: diff < 3600_000 };
}
